import React from 'react';
import './Aproach.css'
const Aproach = ({dark}) => {
    return (
       <div className='aproach'>
            <div className='container'>
                <h1 className={dark?'dark-aproach-header':'light-aproach-header'} style={{fontSize:"40px",fontWeight:"bold"}}>Our approach</h1>
            <div className='d-flex justify-content-center'>
            
                <div className='aproach-item  my-2'>
                    <div className='aproach-list'> <h1>01</h1></div>
                    <div className='aproach-text'>
                    <div className='requirment'>
                        <h4>Requirements</h4>
                        <p>The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex! Fox</p>
                    </div>
                    <div>
                    <i className="fas fa-cogs fa-3x aproach-icon"></i>
                    </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
            
                <div className='aproach-item my-2'>
                <div className='aproach-list'> <h1>02</h1></div>
                    <div className='aproach-text'>
                    <div className='requirment'>
                        <h4>Flow chart</h4>
                        <p>The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex! Fox</p>
                    </div>
                    <div>
                    <i className="fas fa-cogs fa-3x aproach-icon"></i>
                    </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
            
                <div className='aproach-item my-2'>
                    <div className='aproach-list'> <h1>03</h1></div>
                    <div className=' aproach-text'>
                    <div className='requirment'>
                        <h4>Design</h4>
                        <p>The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex! Fox</p>
                    </div>
                    <div>
                    <i className="fas fa-cogs fa-3x aproach-icon"></i>
                    </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
            
                <div className='aproach-item my-2'>
                    <div className='aproach-list'> <h1>04</h1></div>
                    <div className=' aproach-text'>
                    <div className='requirment'>
                        <h4>Develop</h4>
                        <p>The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex! Fox</p>
                    </div>
                    <div>
                    <i className="fas fa-cogs fa-3x aproach-icon"></i>
                    </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
            
                <div className='aproach-item my-2'>
                    <div className='aproach-list'> <h1>05</h1></div>
                    <div className=' aproach-text'>
                    <div className='requirment'>
                        <h4>Test</h4>
                        <p>The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex! Fox</p>
                    </div>
                    <div>
                    <i className="fas fa-cogs fa-3x aproach-icon"></i>
                    </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center'>
            
                <div className='aproach-item my-2'>
                    <div className='aproach-list'> <h1>06</h1></div>
                    <div className=' aproach-text'>
                    <div className='requirment'>
                        <h4>Delivery</h4>
                        <p>The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymph, for quick jigs vex! Fox</p>
                    </div>
                    <div>
                    <i className="fas fa-cogs fa-3x aproach-icon"></i>
                    </div>
                    </div>
                </div>
            </div>
      
        </div>
       </div>
    );
};

export default Aproach;